import React from 'react'
import { IconProps } from './SliderIcon'

/**
 * Icono de Chat con verificación
 */
export const ShieldCheckIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  width = 18,
  height = 22,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.5575 9.5L7.5 11.4425L12.4425 6.5L13.5 7.5575L7.5 13.5575L4.5 10.5575L5.5575 9.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.36815 19.0303L9 21.5L13.6318 19.0303C14.9524 18.3278 16.0567 17.279 16.8263 15.9964C17.5958 14.7137 18.0016 13.2458 18 11.75V2C17.9996 1.6023 17.8414 1.22101 17.5602 0.9398C17.279 0.658586 16.8977 0.500417 16.5 0.5H1.5C1.10231 0.500417 0.721019 0.658586 0.439805 0.9398C0.158591 1.22101 0.000421668 1.6023 4.74309e-06 2V11.75C-0.00160025 13.2458 0.404154 14.7137 1.17372 15.9964C1.94328 17.279 3.0476 18.3278 4.36815 19.0303ZM1.5 11.75V2H16.5V11.75C16.5013 12.9739 16.1693 14.175 15.5396 15.2244C14.9099 16.2738 14.0063 17.132 12.9258 17.7067L9 19.8L5.0742 17.7067C3.99369 17.132 3.0901 16.2738 2.46041 15.2244C1.83072 14.175 1.49871 12.9739 1.5 11.75Z"
        fill={color}
      />
    </svg>
  )
}

export default ShieldCheckIcon
